import defaults from './accessDefaults.js'

const state = Object.assign({}, defaults)

export default state
